export default __webpack_public_path__ + "static/media/placeholder_store04-nl-web.36090c7c.png";